import { Row } from 'components/base';
import * as Card from 'components/card';
import { LinkButton } from 'components/input';
import type React from 'react';
import { strings } from 'strings';

interface MeetingActionsCardProps {
  patientId: string;
}

// NOTE: This screen is not being used anywhere
export const MeetingActionsCard: React.FC<MeetingActionsCardProps> = ({
  patientId,
}) => (
  <Card.BaseWrapper>
    <Row>
      <LinkButton
        text={strings.JoinMeeting}
        href={`/patient/${patientId}/communication`}
      />
    </Row>
  </Card.BaseWrapper>
);
